import { render, staticRenderFns } from "./Host.vue?vue&type=template&id=4c8e51ee"
import script from "./Host.vue?vue&type=script&lang=js"
export * from "./Host.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports